import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=3c76cbcb&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=3c76cbcb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76cbcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c76cbcb')) {
      api.createRecord('3c76cbcb', component.options)
    } else {
      api.reload('3c76cbcb', component.options)
    }
    module.hot.accept("./ProjectBoard.vue?vue&type=template&id=3c76cbcb&scoped=true", function () {
      api.rerender('3c76cbcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pm/project/ProjectBoard.vue"
export default component.exports